import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { BackDrop, ModalStyle } from './ModalStyles';
import ReactDOM from 'react-dom';
import JesuisJechercheContext from '../../../../application/Context/JesuisJechercheContext';
var Backdrop = function () {
    var handleHideThreadForm = useContext(JesuisJechercheContext).handleHideThreadForm;
    return _jsx(BackDrop, { onClick: handleHideThreadForm, children: " " });
};
var ModalOverlay = function (_a) {
    var children = _a.children;
    return (_jsx("div", { children: _jsxs(ModalStyle, { children: [" ", children, " "] }) }));
};
export var Modal = function (_a) {
    var children = _a.children;
    var portalElemnt = document.getElementById('overlays');
    return (_jsxs(React.Fragment, { children: [ReactDOM.createPortal(_jsx(Backdrop, {}), portalElemnt), ReactDOM.createPortal(_jsxs(ModalOverlay, { children: [" ", children, " "] }), portalElemnt)] }));
};
